/* eslint-disable  */
//@ts-nocheck
import { ReactNode, useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { InputLabel } from './InputLabel';
import { useGetter, useMouseDownOutside } from './utils';

const ValueListItem = styled.div`
  & + & {
    border-top: 2px solid #f7f7fb;
  }
`;

export const Select = <V extends unknown>({
  value,
  valueList,
  onChange,
  label,
}: {
  value: V;
  valueList: { value: V; label?: ReactNode; labelWhenSelected?: ReactNode }[];
  label?: string;
  onChange: (val: V) => any;
}) => {
  const [open, setOpen] = useState(false);

  const getOpen = useGetter(open);

  const dropdownRef = useRef<HTMLDivElement>(null!);

  const foundValue = useMemo(
    () =>
      valueList.find((x) => JSON.stringify(x.value) === JSON.stringify(value)),
    [value],
  );

  useMouseDownOutside(dropdownRef, () => {
    if (getOpen()) setOpen(false);
  });

  return (
    <div className="cursor-pointer">
      <InputLabel {...{ label }} />

      <div className="relative" ref={dropdownRef}>
        <div
          className="font-semibold px-4 py-2 rounded-lg flex items-center justify-between border-2 border-[#DAE1ED] bg-[#FAFCFD]"
          onClick={() => setOpen((x) => !x)}
        >
          {
            (foundValue?.labelWhenSelected ??
              foundValue?.label ??
              foundValue?.value) as ReactNode
          }

          <FontAwesomeIcon
            icon={faChevronDown}
            className="text-[#101426] text-md ml-3 margin-right[-7px] leading-none"
          />
        </div>
        {open ? (
          <div className="absolute top-full w-full mt-2 z-[1] rounded-lg border-2 border-[#DAE1ED] bg-[#FAFCFD]">
            {valueList.map((el, i) => (
              <ValueListItem
                className="px-4 py-3 flex items-center justify-between"
                key={i}
                onClick={() => {
                  onChange(el.value);
                  setOpen(false);
                }}
              >
                <div>{el.label ?? (el.value as ReactNode)}</div>
                {foundValue?.value === el.value ? (
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="text-[#101426] text-md ml-3 margin-right[-7px] leading-none"
                  />
                ) : null}
              </ValueListItem>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};
